module.exports = __webpack_public_path__ + "assets/773d604421b86c4b5318b41084e5bf31.mp3";